import { ValuesProps } from './PaletteProps';
import hexToRgba from '../utils/hexToRgba';

const values: ValuesProps = {
  color1: {
    hex: '#002878',
    get rgba() {
      return hexToRgba(this.hex);
    },
  },
  color2: {
    hex: '#002878',
    get rgba() {
      return hexToRgba(this.hex);
    },
  },
  color3: {
    hex: '#525260',
    get rgba() {
      return hexToRgba(this.hex);
    },
  },
  color4: {
    hex: '#E5E9F1',
    get rgba() {
      return hexToRgba(this.hex);
    },
  },
  color5: {
    hex: '#FFFFFF',
    get rgba() {
      return hexToRgba(this.hex);
    },
  },
  color6: {
    hex: '#52AF00',
    get rgba() {
      return hexToRgba(this.hex);
    },
  },
  color7: {
    hex: '#F9A825',
    get rgba() {
      return hexToRgba(this.hex);
    },
  },
  color8: {
    hex: '#D8241C',
    get rgba() {
      return hexToRgba(this.hex);
    },
  },
  color9: {
    hex: '#F6F6F7',
    get rgba() {
      return hexToRgba(this.hex);
    },
  },
  color10: {
    hex: '#A8A8AF',
    get rgba() {
      return hexToRgba(this.hex);
    },
  },
  color11: {
    hex: '#EDF7E5',
    get rgba() {
      return hexToRgba(this.hex);
    },
  },
  color12: {
    hex: '#FDF6E9',
    get rgba() {
      return hexToRgba(this.hex);
    },
  },
  color13: {
    hex: '#FDF2F2',
    get rgba() {
      return hexToRgba(this.hex);
    },
  },
  color14: {
    hex: '#7F93BB',
    get rgba() {
      return hexToRgba(this.hex);
    },
  },
};

export default values;
